export const identifyOS = function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

export const identifyDesktop = function isMacintosh() {
  if (navigator.platform.indexOf('Mac') > -1) {
    return 'mac'
  }
  else {
    return 'win'
  }
}

export const isChrome = function () { // only identify on mobile
  // Return cached result if avalible, else get result then cache it.
  var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  //alert(isChrome)
  console.log(isChrome)
  return isChrome
}



// WEBPACK FOOTER //
// ./src/helper/identifyOS.js